import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useNavigate } from 'js/hooks/navigate';

import * as Types from './types';
import * as constants from '../constants';

export const useRunSlideAction = () => {
    const navigate = useNavigate();

    return useCallback(({ slideAction, slideActionURL, slideActionGameCode }: Types.IUseRunSlideActionOptions): void => {
        if (!slideAction) {
            return;
        }

        switch (slideAction) {
            case constants.SLIDE_ACTION_TYPES.url: {
                slideActionURL && navigate(slideActionURL);

                break;
            }

            case constants.SLIDE_ACTION_TYPES.gameLaunch: {
                if (!slideActionGameCode) {
                    break;
                }

                dispatcher.dispatch('game:launch:maybe', { gameCode: slideActionGameCode, container: 'Banner' });
                dispatcher.dispatch('game:launch', { code: slideActionGameCode, mode: 1 });

                break;
            }

            default:
                break;
        }
    }, [navigate]);
};
